






























import { Vue, Component, Prop } from "vue-property-decorator";
import accountStatus from "../modules/trainAccountStatus.vue";
import trainService from "@/service/trainService";
import { Dialog } from "vant";
@Component({
  components: {
    "account-status": accountStatus,
  },
})
export default class Train extends Vue {
  verifyTimer: any = null;
  mounted() {
  }

  activated() {
    this.validOuterUserAct(false);
  }

  gotoTrainAccount() {
    this.$router.push("/mall/trainAccount");
  }
  @Prop()
  model!: { OuterUserAct: string , AccountID:string };


 pollVerifyResult(): Promise<boolean> {
    return new Promise((resolve) => {
      this.verifyTimer = setInterval(() => {
        trainService.FaceValid(this.model.AccountID).then((res) => {
          if(!res.isSucc){
            clearInterval(this.verifyTimer);
            this.$toast.fail(res.message || '验证失败，请重试');
            resolve(false);
          }
          if (res.isSucc) {
            if(res.message && res.message.indexOf("验证成功") > -1){
            this.$toast.success(res.message);
            clearInterval(this.verifyTimer);
            resolve(true);
            }
          }
        }).catch(() => {
          clearInterval(this.verifyTimer);
          this.$toast.fail('验证结果查询失败，请重试');
          resolve(false);
        });
      }, 1500);
    });
  }

  validOuterUserAct(isWarn: boolean = false): Promise<boolean> {
    let __self = this;
    return trainService.validOuterUserAct().then(json => {
      this.isLink12306 = false;
      if (!json.isSucc || !json.result || !json.result.OuterUserAct) {
        if (isWarn) {
          // 如果包含人脸就走这个逻辑
          if(json.message == '该账号需要动态⼈脸核验'){
            // 返回一个Promise，等待人脸验证结果
            return new Promise((resolve) => {
              trainService.GetValidUrl(this.model.AccountID).then((uRes:any) => {
                if (!uRes.isSucc) {
                  this.$toast.fail(uRes.message);
                  resolve(false);
                  return;
                }
                this.$dialog
                  .alert({
                    message: json.message,
                    confirmButtonText: '前往验证',
                    closeOnPopstate: true,
                  })
                  .then(() => {
                      // 转码
                      const callBackUrl = encodeURIComponent(`${window.location.origin}/mall/redirecting`);
                      // 解析uRes.data中的URL并替换callBackUrl参数
                      const url = new URL(uRes.data);
                      url.searchParams.set('callBackUrl', callBackUrl); 
                      window.open(url.toString(), "_blank");
                      // 等待人脸验证结果
                      this.pollVerifyResult().then((verifyResult) => {
                          resolve(verifyResult);
                      });
                   })
                  .catch(() => {
                    resolve(false);
                  });
              }).catch(() => {
                resolve(false);
              });
            });
          } 
          let message = `12306账户绑定状态存在异常情况，需重新绑定。异常信息：${json.message}`
          let title = `账号绑定状态异常，请重新绑定`;
          if (json.message == "没有对应的12306账号") {
            title = "账户绑定提醒";
            message = "铁路部门规定购票必须实名制,请登录你的12306账号后购票！";
          }
          Dialog.alert({ title, message, messageAlign: "left" }).then(() => {
            __self.gotoTrainAccount();
          });
        }
        return false;
      }
      this.model.OuterUserAct = json.result.OuterUserAct!;
      this.model.AccountID = json.result.AccountID!;
      this.isLink12306 = true;
      return true;
    });
  }
  maskCode(value?: string) {
    if (!value) return "";
    if (/^\d{17}[\dxX]$/.test(value)) return value.replace(/^(\d{4})\d{11}([\dxX]{3})$/gi, "$1***********$2");
    if (/^\d{11}$/.test(value)) return value.replace(/^(\d{3})\d{4}([\dxX]{4})$/gi, "$1****$2");
    if (/\d{4}-\d{2}-\d{2}/gi.test(value)) return value.replace(/^(\d{2})\d{2}-\d{2}-(\d{2})$/gi, "$1**-**-$2");
    if (/.+@\w+\.\w+/gi.test(value)) return value.replace(/(\w{1,3}).+@\w+\.(\w+)/gi, "$1**@**.$2");
    if (/^\w+\w{4}\w+$/.test(value)) return value.replace(/^(\w{1,3})\w+(\w{2})$/gi, "$1****$2");
    return value;
  }
  isLink12306 = false;
}
